import { gql } from '@lcs/shared/api';

export const getAllowedIpRegisterQuery = gql`
   query GetAllowedIpRegister($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      allowedIpAddressesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            allowedIpAddressId
            ipAddress
            accountId
            qManageTicketId
            originatingType
            status
            requestedByUserId
            createDate
            updateDate

            account {
               accountId
               name
            }

            requestedByUser {
               userId
               name
            }
         }
      }
   }
`;
